import React, { Component } from "react"
import { Card, Col, Row } from "reactstrap"
import { withRouter } from "react-router-dom"
import PropTypes from "prop-types"
import { withTranslation } from "react-i18next"
import logo from "../../assets/images/edurasite700.png"
import APIS from "../../apis"
import { FaEye, FaCalendarAlt, FaCheck, FaHome } from "react-icons/fa"

const tiles = [
    {
        title: "L'emploi du temps",
        icon: <FaHome />,
        color: "#39a998",
        link: "/Emploi",
    },
    {
        title: "L'emploi des examens session principale",
        icon: <FaCalendarAlt />,
        iconCheck: <FaCheck />,
        color: "#2970aa",
        link: "/CalendrierExamen",
    },
    {
        title: "L'emploi des examens session de contrôle",
        icon: <FaCalendarAlt />,
        iconCheck: <FaCheck />,
        color: "#f4c581",
        link: "/CalendrierExamenControle",
    },
    // Vous pouvez ajouter plus de tiles ici si nécessaire
]

class NewsGrid extends Component {
    constructor(props) {
        super(props)
        this.state = {
            paused: false,
            newsItems: []
        }
    }
    componentDidMount() {
        // Chargement des actualités si l'utilisateur est connecté
        if (localStorage.getItem("userAuthEtudiant")) {
            const userAuthEtudiant = JSON.parse(localStorage.getItem("userAuthEtudiant"))
            const etudiant_id = userAuthEtudiant.user.id_etudiant
            const anneeScolaire = JSON.parse(localStorage.getItem("anneeScolaire"))
            const annee_id = anneeScolaire.Annee.id
            // Appel API pour récupérer les actualités
            APIS.post("etudiant/actualites_etudiant", { annee_id, etudiant_id })
                .then(resR => {
                    if (resR.data && resR.data.Actualites) {
                        this.setState({ newsItems: resR.data.Actualites })
                    }
                })
                .catch(error => {
                    console.error("Erreur lors du chargement des actualités:", error)
                })
        }
    }
    toggleDetail = (link) => {
        this.props.history.push(link)
    }
    render() {
        const tickerStyle = {
            width: "100%",
            overflow: "hidden",
            backgroundColor: "#ff0000",
            color: "#fff",
            padding: "10px 0",
            cursor: "pointer",
            borderRadius: "4px",
            fontSize: "14px",
        };
        const trackStyle = {
            display: "inline-flex",
            whiteSpace: "nowrap",
            animation: "scroll 90s linear infinite",
            animationPlayState: this.state.paused ? "paused" : "running",
        };
        const dateStyle = {
            backgroundColor: "#000",
            color: "#fff",
            padding: "2px 8px",
            borderRadius: "4px",
            marginRight: "10px",
        };
        const itemStyle = {
            marginRight: "50px",
            display: "flex",
            alignItems: "center",
        };
        return (
            <React.Fragment>
                <Col md={12} lg={12} xl={12}>
                    <Card>
                        <div>
                            <Row className="justify-content-center">
                                <Col xl={11}>
                                    <div>
                                        <Row className="align-items-center">
                                            <Col style={{ marginTop: "15px", marginBottom: "15px" }} md={12}>
                                                <div
                                                    style={tickerStyle}
                                                    onMouseEnter={() => this.setState({ paused: true })}
                                                    onMouseLeave={() => this.setState({ paused: false })}
                                                >
                                                    <div style={trackStyle}>
                                                        {this.state.newsItems.map((item, index) => {
                                                            const [date, ...textParts] = item.split(" : ");
                                                            const text = textParts.join(" : ");
                                                            return (
                                                                <span key={index} style={itemStyle}>
                                                                    <span style={dateStyle}>{date}</span>
                                                                    <span>{text}</span>
                                                                </span>
                                                            );
                                                        })}
                                                        {/* Dupliquer les items pour un scroll continu */}
                                                        {this.state.newsItems.map((item, index) => {
                                                            const [date, ...textParts] = item.split(" : ");
                                                            const text = textParts.join(" : ");
                                                            return (
                                                                <span key={`dup-${index}`} style={itemStyle}>
                                                                    <span style={dateStyle}>{date}</span>
                                                                    <span>{text}</span>
                                                                </span>
                                                            );
                                                        })}
                                                    </div>
                                                    <style>
                                                        {`
                                                            @keyframes scroll {
                                                                0% { transform: translateX(0); }
                                                                100% { transform: translateX(-50%); }
                                                            }
                                                        `}
                                                    </style>
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row className="align-items-center">
                                            <Col md={6}>
                                                <img src={logo} alt="logo" style={{ maxWidth: "100%" }} />
                                            </Col>
                                            <Col md={6} style={{ top: "15px" }}>
                                                <div style={{ display: "flex", justifyContent: "end" }}>
                                                    <a
                                                        href="http://www.edura.tn/"
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        style={{
                                                            color: "#2F70A9",
                                                            fontSize: "16px",
                                                            display: "flex",
                                                            justifyContent: "end",
                                                        }}
                                                    >
                                                        www.edura.tn
                                                    </a>
                                                </div>
                                            </Col>
                                        </Row>
                                        <hr className="mb-4" />

                                        <Row style={{display: "flex", justifyContent: "center"}}>
                                            {tiles.map((tile, index) => (
                                                <Col key={index} md={4} className="mb-4">
                                                    <div
                                                        key={index}
                                                        style={{
                                                            backgroundColor: tile.color,
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            justifyContent: "space-between",
                                                            borderRadius: "10px",
                                                            cursor: "pointer",
                                                            boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
                                                            transition: "transform 0.3s, box-shadow 0.3s",
                                                            color: "#fff",
                                                            minHeight: "250px", // Hauteur minimale pour uniformité
                                                        }}
                                                        onMouseEnter={e => {
                                                            e.currentTarget.style.transform = "scale(1.05)"
                                                            e.currentTarget.style.boxShadow =
                                                                "0 10px 20px rgba(0,0,0,0.3)"
                                                        }}
                                                        onMouseLeave={e => {
                                                            e.currentTarget.style.transform = "scale(1)"
                                                            e.currentTarget.style.boxShadow =
                                                                "0 4px 8px rgba(0,0,0,0.2)"
                                                        }}
                                                    >
                                                        <div
                                                            style={{
                                                                padding: "15px",
                                                                textAlign: "center",
                                                                flexGrow: 1,
                                                                display: "flex",
                                                                flexDirection: "column",
                                                                justifyContent: "center",
                                                            }}
                                                        >
                                                            <div
                                                                style={{
                                                                    backgroundColor: "#fff",
                                                                    borderRadius: "50%",
                                                                    width: "70px",
                                                                    height: "70px",
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    margin: "0 auto 15px auto",
                                                                }}
                                                            >
                                                                {React.cloneElement(tile.icon, {
                                                                    size: 35,
                                                                    color: tile.color,
                                                                })}
                                                            </div>
                                                            <div
                                                                style={{ fontSize: "16px", fontWeight: "bold" }}
                                                            >
                                                                {tile.title}
                                                            </div>
                                                        </div>
                                                        <div
                                                            style={{
                                                                backgroundColor: "#fff",
                                                                padding: "8px",
                                                                display: "flex",
                                                                justifyContent: "space-around",
                                                                alignItems: "center",
                                                                borderTop: `2px solid ${tile.color}`,
                                                            }}
                                                        >
                                                            <a
                                                                style={{
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    padding: "5px 10px",
                                                                    border: `1px solid ${tile.color}`,
                                                                    borderRadius: "5px",
                                                                    color: tile.color,
                                                                    fontWeight: "bold",
                                                                    textDecoration: "none",
                                                                    gap: "11px",
                                                                    transition: "0.3s",
                                                                }}
                                                                onMouseEnter={e => {
                                                                    e.currentTarget.style.backgroundColor =
                                                                        tile.color
                                                                    e.currentTarget.style.color = "#fff"
                                                                }}
                                                                onMouseLeave={e => {
                                                                    e.currentTarget.style.backgroundColor = "#fff"
                                                                    e.currentTarget.style.color = tile.color
                                                                }}
                                                                onClick={() => this.toggleDetail(tile.link)}
                                                            >
                                                                <FaEye
                                                                    style={{ fontSize: "20px", color: "inherit" }}
                                                                />{" "}
                                                                Détail
                                                            </a>
                                                        </div>
                                                    </div>
                                                </Col>
                                            ))}
                                        </Row>

                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </Card>
                </Col>
            </React.Fragment>
        )
    }
}

NewsGrid.propTypes = {
    t: PropTypes.any,
    history: PropTypes.object.isRequired
}

export default withRouter(withTranslation()(NewsGrid))